export const IMS_TYPE__RADIO_TECHNOLOGY = 'radio_technology';
